import { render, staticRenderFns } from "./ExamineRecord.vue?vue&type=template&id=4eb500c4&scoped=true&"
import script from "./ExamineRecord.vue?vue&type=script&lang=js&"
export * from "./ExamineRecord.vue?vue&type=script&lang=js&"
import style0 from "./ExamineRecord.vue?vue&type=style&index=0&id=4eb500c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb500c4",
  null
  
)

export default component.exports